import { memberApis } from '@apis/dashboard/memberApis';
import { useQuery } from '@hooks/useQuery';
import { DashboardMemberQuery } from '@models/Member';

export const useMemberList = (query: DashboardMemberQuery) => {
  return useQuery(['/dashboard/member/', query], () =>
    memberApis
      .get('/dashboard/member/', {
        query,
      })
      .then((r) => r[200]!),
  );
};
